import React, { useState, useEffect } from "react";
import { fetchSamples } from "./Utils/SamplesFetch";
import Samples from "./Samples";
import UserContext from "../../lib/UserContext";

export default function SingleSample({ sample_id, clientView }) {
  const [sampleList, setSampleList] = useState(null);
  const findSamples = () => {
    fetchSamples({
      sample_ids: [sample_id],
      show_all_samples: true,
    }).then((sample_list) => setSampleList(sample_list));
  };

  useEffect(
    () => {
      setSampleList(null);
      findSamples();
    },
    [sample_id]
  );

  if (!sampleList) return null;
  return (
    <UserContext.Provider value={{ clientView }}>
      <Samples
        sample_list={sampleList}
        clientView={false}
        showAttributes={false}
        reloadData={findSamples}
        showGroupBy={false}
        oneSample={true}
      />
    </UserContext.Provider>
  );
}
